import toastr from 'toastr'
import axios from 'axios'
import Vue from 'vue'
import {
  keyBy
} from 'lodash'
import {
  ActivationStatus
} from '@/enums/add-on/activation-status'

const state = {
  addOns: {},
  addOnSubscriptions: {} // Subscriptions for chain, indexed by addOnId.
}

const getters = {
  getAddOns (state) {
    return Object.values(state.addOns)
  },

  getAddOnSubscriptionsByAddOnId: (state) => (addOnId) => {
    return state.addOnSubscriptions[addOnId] || []
  },

  getActivationStatusForAddon: (state, getters) => (addOnId) => {
    let subscriptions = getters.getAddOnSubscriptionsByAddOnId(addOnId)
    if (window.CONFIG.departments.length === 1) {
      subscriptions = subscriptions.filter(s => s.SiteId === window.CONFIG.user.CurrentSiteId)
    }
    // There are more statuses, but for now try to keep it simple.
    // At least one active
    if (subscriptions.some(s => s.SubscriptionStatus === ActivationStatus.Subscribed)) {
      return ActivationStatus.Subscribed
    }
    // At least one activating
    if (subscriptions.some(s => s.SubscriptionStatus === ActivationStatus.InActivationProssess)) {
      return ActivationStatus.InActivationProssess
    }
    return ActivationStatus.NeverSubscribed
  }

}

const mutations = {
  setAddOns (state, addOns) {
    let addOnsById = keyBy([].concat(addOns), addOn => addOn.Id)
    state.addOns = Object.assign({}, state.addOns, addOnsById)
  },
  setAddOnSubscriptions: (state, subscriptions) => {
    let s = [].concat(subscriptions)
    if (s.length) {
      Vue.set(state.addOnSubscriptions, s[0].AddOnId, s)
    }
  }
}

const actions = {
  async fetchAddOns ({
    commit
  }) {
    try {
      let response = await axios.post(`/api/ajax/AddOns/GetAddOns`)
      let addOns = response.data.Array
      commit('setAddOns', addOns)
    } catch (err) {
      toastr.error('Feilmelding', 'Klarte ikke å hente utvidelser')
      console.error(err)
    }
  },

  async fetchAddOnSubscriptions ({
    commit
  }, {
    addOnId,
    chainId
  }) {
    try {
      let response = await axios.post(`/api/ajax/AddOns/GetAddOnSubscriptions`, {
        addOnId,
        chainId
      })
      let subscriptions = response.data
      subscriptions = subscriptions.map(s => {
        s.AddOnId = addOnId
        return s
      })
      commit('setAddOnSubscriptions', subscriptions)
    } catch (err) {
      toastr.eror('Feilmelding', 'Klarte ikke å hente abonnementstatus')
      console.error(err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
